import { useCallback, useEffect } from "react";
import type { Quote } from "features/market/lib/quotes";
import { useMarketQuotePanels, useMarketQuotesContext } from "features/market/context/MarketQuotesContext";
import type { PanelTypeWithCrypto } from "features/market/api/MarketQuotes";

export interface MarketQuotesData {
  quotes: Quote[];
  updatedAt: string;
}

interface UseMarketQuotesReturn {
  data: MarketQuotesData | null;
  loading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

export function useMarketQuotes(panel: PanelTypeWithCrypto): UseMarketQuotesReturn {
  const { refreshQuotes, requestLoad } =
    useMarketQuotesContext();
  const panelState = useMarketQuotePanels([panel])[panel];

  useEffect(() => {
    requestLoad(panel);
  }, [panel, requestLoad]);
  const refresh = useCallback(() => refreshQuotes(panel), [panel, refreshQuotes]);

  return {
    data: panelState?.data ?? null,
    loading: panelState?.loading ?? false,
    error: panelState?.error ?? null,
    refresh,
  };
}
